export const translations = {
  es: {
    // Header & Perfil Conductor
    available: "DISPONIBLE",
    paused: "EN PAUSA",
    mobile: "Móvil",
    change: "Cambiar",
    push_ok: "PUSH OK",
    configure: "CONFIGURAR",
    today: "HOY",
    current_month: "MES ACTUAL",
    view_list: "VER LISTADO",
    gps_permission: "PERMISO GPS",
    view_notice: "📍 VER AVISO",
    my_profile: "Mi Perfil",
    logout: "Cerrar Sesión",
    admin: "ADMIN",
    language: "Idioma",
    phone: "TELÉFONO",
    email: "EMAIL",
    role: "ROL",
    not_registered: "No registrado",
    my_documents: "Mis Documentos",
    service_certificate: "Certificado de Servicios",
    my_payments_settlements: "Mis Pagos / Liquidaciones",
    my_schedule_availability: "Mi Horario y Disponibilidad",
    close: "Cerrar",
    delete_account: "Eliminar Cuenta",

    // Pestañas Conductor (Tabs)
    tab_new: "NUEVOS",
    tab_agenda: "AGENDA",
    tab_tomorrow: "MAÑANA",
    tab_history: "HISTORIAL",
    tab_payments: "LIQUIDACIONES",

    // Estados de viaje (Badges & Tablas)
    status_pending: "Pendiente",
    status_assigned: "Asignado",
    status_confirmed: "Confirmado",
    status_en_route: "En Camino",
    status_arrived: "En Posición",
    status_on_board: "A Bordo / En Ruta",
    status_completed: "Finalizado",
    status_cancelled: "Cancelado",
    status_cancelled_paid: "Cancelado con Cargo",
    status_no_show: "No Show",
    status_anulado: "ANULADO",

    // Acciones y Botones del Conductor
    btn_accept: "¡ACEPTAR!",
    btn_reject: "RECHAZAR",
    btn_start_trip: "EN CAMINO",
    btn_arrived: "EN POSICIÓN",
    btn_onboard: "PASAJERO A BORDO",
    btn_finish: "FINALIZAR SERVICIO",
    btn_navigate: "Navegar",
    btn_call: "Llamar",
    btn_whatsapp: "WhatsApp",
    btn_flight: "Vuelo",
    btn_chat: "Chat Pasajero",
    btn_release_trip: "⚠️ No puedo realizar este viaje (Liberar)",
    release_trip_confirm: "¿Liberar este servicio? Se devolverá a la central.",
    time_restriction_notice: "* Se habilitará 2 horas antes del servicio.",

    // Detalles del Servicio
    lbl_passenger: "Pasajero",
    lbl_origin: "Origen",
    lbl_destination: "Destino",
    lbl_pickup_time: "Hora recogida",
    lbl_flight: "Vuelo",
    lbl_suitcases: "Maletas",
    lbl_notes: "Notas",
    lbl_earnings: "Ganancia",
    lbl_cost_center: "Centro de Costo",
    lbl_no_trips: "No tienes servicios programados en esta sección.",
    lbl_waiting_time: "Tiempo de espera",
    lbl_contact: "Contactar Pasajero",

    // Ofertas ASAP / Urgentes
    asap_title: "¡NUEVO SERVICIO INMEDIATO DISPONIBLE!",
    asap_subtitle: "Un servicio urgente requiere confirmación rápida.",
    asap_expires: "Expira en",

    // Liquidaciones
    settlements_title: "Mis Liquidaciones",
    settlements_no_records: "No hay liquidaciones registradas aún.",
    settlement_period: "Periodo",
    settlement_amount: "Total a Pagar",
    settlement_trips: "Viajes",
    settlement_status_paid: "PAGADO",
    settlement_status_pending: "PENDIENTE",
    btn_download_receipt: "Ver Comprobante",

    // Portal Proveedor - Navegación Principal
    provider_title: "EmiGo Proveedores",
    provider_role_badge: "PROVEEDOR",
    provider_syncing: "Sincronizando datos...",
    provider_dispatch_tab: "📅 Despacho y Viajes",
    provider_claims_tab: "⚠️ Reclamos e Incidencias",
    provider_fleet_tab: "🚙 Mi Flota",
    provider_tariffs_tab: "💰 Mi Tarifario",
    provider_sentinel_tab: "🤖 Bot Centinela",
    provider_quality_tab: "⭐ Calidad",
    provider_subtab_active: "En Curso / Por Despachar",
    provider_subtab_history: "Historial",
    provider_schedule_btn: "Enviar Agenda a Choferes",
    provider_no_trips: "No hay servicios encontrados para los filtros seleccionados.",

    // Portal Proveedor - Despacho Diario & Filtros
    daily_dispatch: "Despacho Diario",
    all: "Todos",
    today_filter: "Hoy",
    month: "Mes",
    range: "📅 Rango",
    dispatch_subtab_speech: "Locución",
    history: "Historial",
    reload: "🔄 Recargar",
    unassigned: "Sin Asignar",
    filters: "Filtros",
    filter_clients: "Clientes...",
    filter_driver_vehicle: "Móvil / Chofer...",
    filter_status: "Estados...",
    filter_areas: "Áreas...",
    filter_cost_centers: "Centros Costo...",
    filter_requesters: "Solicitantes...",
    filter_passenger: "Pasajero...",
    services_count: "SERVICIOS",
    total_estimated_payment: "PAGO ESTIMADO TOTAL",
    total_payment: "PAGO TOTAL",
    estimated_payment: "PAGO ESTIMADO",
    active_dispatch_title: "Despacho Activo",
    in_course: "En Curso",
    completed_count: "Finalizados",
    no_services_found: "No se encontraron servicios en esta sección.",

    // Portal Proveedor - Columnas Tabla
    th_datetime: "Fecha/Hora",
    th_type: "Tipo",
    th_client: "Cliente",
    th_passenger: "Pasajero",
    th_route: "Ruta (Origen / Destino)",
    th_general_notes: "Obs. Generales",
    th_driver_notes: "Obs. Conductor",
    th_estimated_time: "T. Est",
    th_status: "Estado",
    th_est_payment: "Pago Est.",
    th_payment: "Pago",
    th_vehicle: "Móvil",
    th_actions: "Acciones",

    // Portal Proveedor - Botones de Tabla & Filas
    assign: "Asignar",
    assign_vehicle: "Asignar Móvil",
    change_btn: "Cambiar",
    confirm: "Confirmar",
    accept: "Aceptar",
    start_route: "▶ Iniciar Ruta",
    arrived_origin: "📍 Llegó a Origen",
    passenger_onboard: "👋 Pasajero a Bordo",
    finish_trip: "🏁 Finalizar Viaje",
    release: "✕ Liberar",
    manage_urgent: "¡GESTIONAR!",
    urgent: "URGENTE",
    no_driver: "Sin chofer asignado",
    driver_word: "Chofer",
    vehicle_word: "Móvil",
    vehicle_not_assigned: "⚠️ Móvil No Asignado",
    audit_trip: "Auditar",
    page_x_of_y: "Pág",
    view_per_page: "Ver:",

    // Portal Proveedor - Pestaña Mi Flota
    fleet_title: "🚙 Autogestión de Flota",
    fleet_subtitle: "Administra los conductores, móviles y turnos activos en tu zona.",
    tab_drivers: "👤 Conductores",
    tab_vehicles: "🚙 Vehículos",
    tab_capacities: "⚙️ Capacidades",
    drivers_list_title: "Listado de Conductores",
    register_driver_btn: "Registrar Conductor",
    no_drivers_registered: "No tienes conductores registrados.",
    driver_th_name_rut: "Nombre / RUT",
    driver_th_contact_email: "Contacto / Email",
    driver_th_shift_status: "Estado Turno",
    driver_th_assigned_vehicle: "Móvil Asignado",
    online: "Online",
    offline: "Inactivo",
    on_shift_online: "En Turno (Online)",
    off_service: "Fuera de Servicio",
    no_vehicle: "Sin móvil",
    edit: "Editar",

    // Modales Conductor / Vehículo
    new_driver_title: "👤 Nuevo Conductor",
    edit_driver_title: "👤 Editar Conductor",
    full_name_lbl: "Nombre Completo *",
    rut_id_lbl: "RUT / Identificación *",
    phone_lbl: "Teléfono *",
    email_user_lbl: "Email / Usuario *",
    password_lbl: "Contraseña de Acceso",
    password_keep_ph: "Dejar en blanco para mantener",
    password_min_ph: "Mínimo 6 caracteres",
    active_driver_lbl: "Conductor Activo",
    show_pricing_lbl: "Permitir ver precios de viajes en portal móvil",
    cancel: "Cancelar",
    save_driver_btn: "Guardar Conductor",

    new_vehicle_title: "🚙 Nuevo Vehículo",
    edit_vehicle_title: "🚙 Editar Vehículo",
    internal_code_lbl: "Código Interno / Móvil *",
    plate_lbl: "Patente / Placa *",
    brand_lbl: "Marca *",
    model_lbl: "Modelo *",
    year_lbl: "Año *",
    color_lbl: "Color",
    category_lbl: "Tipo / Capacidad *",
    assigned_driver_lbl: "Conductor Asociado",
    active_vehicle_lbl: "Vehículo Activo",
    save_vehicle_btn: "Guardar Vehículo",

    // Modal Asignar / Editar Viaje
    assign_modal_title: "📋 Autoasignar / Editar Reserva",
    assign_modal_vehicle: "Vehículo / Móvil *",
    assign_modal_select_vehicle: "- Seleccione Móvil -",
    assign_modal_assigned_driver: "Conductor Asignado",
    assign_modal_no_driver_warning: "No hay conductor pre-asociado a este móvil",
    assign_modal_link_driver_tip: "⚠️ El móvil seleccionado no tiene conductor asociado. Vincúlelo en \"Mi Flota\" antes de asignar.",
    assign_modal_notes: "Observaciones Generales",
    assign_modal_driver_notes: "Observaciones del Conductor",
    assign_modal_confirm: "Confirmar Asignación",
    waiting_new_services: "Esperando nuevos servicios...",
    no_confirmed_trips_agenda: "Sin servicios confirmados en agenda.",
    no_trips_tomorrow: "No tiene servicios programados para mañana.",
    accept_trip_card: "Aceptar Viaje",
    btn_accept_service: "Aceptar Servicio",
    trip_in_progress: "VIAJE EN CURSO...",
    trips_history_title: "Historial de Viajes",
    loading_month_history: "Cargando historial del mes...",
    no_history_this_month: "No hay servicios en el historial para este mes.",
    agreement: "Convenio",
    agenda_pending_confirm: "AGENDA PENDIENTE DE CONFIRMAR",
    confirm_agenda_reading: "✓ Confirmar Lectura / Enterado",
    agenda_confirmed: "¡Agenda Confirmada!",
    agenda_confirmed_on: "Confirmaste la revisión el",
    at_time_hrs: "a las",
    passenger_list: "LISTA DE PASAJEROS",
    pax_principal: "Principal",
    pax_companion: "Acompañante",
    stop_word: "Parada",
    flight_label: "Vuelo",
    no_phone: "Sin Teléfono",
    no_phone_short: "Sin tel.",
    status_scheduled: "PROGRAMADO",
    new_badge: "NUEVO",
    close_map: "Cerrar Mapa",
    view_map_route: "VER MAPA CON RUTA",
    service_title: "SERVICIO",
    schedule_btn: "Agendar",
    extra_services_title: "SERVICIOS ADICIONALES (EXTRAS)",
    lbl_origin_caps: "ORIGEN",
    lbl_destination_caps: "DESTINO",
    intermediate_stops: "PARADAS INTERMEDIAS",
    general_observations: "OBSERVACIONES GENERALES",
    trip_comments_title: "NOVEDADES / COMENTARIOS DEL VIAJE",
    trip_comments_ph: "Escribe aquí si hubo alguna novedad...",
    arrived_at_stop: "LLEGUÉ A PARADA",
    continue_trip_leave: "CONTINUAR VIAJE (SALIR)",
    completion_summary_title: "Resumen de Finalización",
    completion_details_subtitle: "Detalles del servicio completado:",
    distance_covered: "DISTANCIA RECORRIDA",
    waiting_time_caps: "TIEMPO DE ESPERA",
    trip_fare: "TARIFA VIAJE",
    waiting_payment: "PAGO POR ESPERA",
    important_notice: "Aviso Importante",
    understood: "Entendido",
    pax_on_board_question: "¿Pasajero(s) a Bordo?",
    yes: "Sí",
    no: "No",
    trips_today: "Servicios de Hoy",
    trips_month: "Servicios del Mes",
    no_trips_period: "No se registran servicios completados en este período.",
    total_period: "TOTAL PERÍODO",
    gps_usage_title: "Uso de Ubicación GPS",
    gps_disclosure_text: "Flujo App (EmiGo) recopila y transmite datos de ubicación GPS para permitir el seguimiento en tiempo real de los servicios de transporte asignados a los conductores.",
    gps_background_title: "📌 Transmisión en Segundo Plano:",
    gps_background_desc: "La posición de tu vehículo se compartirá con la central de operaciones y los pasajeros durante la ejecución de un viaje activo, incluso cuando la app esté minimizada o la pantalla esté apagada.",
    understood_and_continue: "Entendido y Continuar",
    no_settlements_month: "No tienes liquidaciones para este mes.",
    refresh: "Actualizar",
    setup_guide_title: "MANUAL DE CONFIGURACIÓN",
    setup_guide_subtitle: "Sigue estos pasos para que los viajes te lleguen al instante y el GPS no se corte.",
    setup_battery_title: "1. Batería (Sin Restricciones)",
    setup_battery_step1: "Ve a Ajustes de tu teléfono.",
    setup_battery_step2: "Busca Aplicaciones y selecciona EmiGo.",
    setup_battery_step3: "Entra en Batería.",
    setup_battery_step4: "Selecciona \"SIN RESTRICCIONES\" (u \"Optimización Desactivada\").",
    setup_why: "¿Por qué? ",
    setup_battery_desc: "Si no lo haces, Android \"duerme\" la app y no recibirás los viajes urgentes (ASAP).",
    setup_data_title: "2. Datos en Segundo Plano",
    setup_data_step1: "En el mismo menú de la app (EmiGo), entra en Datos Móviles.",
    setup_data_step2: "Activa \"Permitir uso de datos en segundo plano\".",
    setup_data_step3: "Activa \"Permitir uso de datos con ahorro de datos\".",
    setup_notif_title: "3. Notificaciones y Sonido",
    setup_notif_step1: "Asegura que en Notificaciones todos los interruptores estén ENCENDIDOS.",
    setup_notif_step2: "Revisa que el volumen de notificaciones esté alto.",
    setup_btn_understood: "¡ENTENDIDO, YA LO CONFIGURÉ!",
    perm_title: "CONFIGURACIÓN REQUERIDA",
    perm_greeting: "¡Hola! Para recibir viajes...",
    perm_desc: "Necesitamos que actives los permisos de GPS y Notificaciones.",
    perm_gps_title: "GPS (Ubicación)",
    perm_gps_desc: "EmiGo recopila datos de ubicación para permitir el seguimiento de tus viajes en tiempo real y la asignación de servicios cercanos, incluso cuando la aplicación está cerrada o no está en uso.",
    perm_notif_title: "Notificaciones",
    perm_notif_desc: "Para avisarte al instante cuando tengas un nuevo servicio.",
    perm_battery_title: "Batería (Sin Restricciones)",
    perm_battery_desc: "Muy importante para que Android no \"duerma\" la app.",
    perm_warning: "Al presionar el botón, el celular te preguntará. Selecciona \"PERMITIR SIEMPRE\".",
    perm_btn_configure: "CONFIGURAR AHORA",
    vehicles_list_title: "Listado de Móviles",
    register_vehicle_btn: "Registrar Móvil",
    no_vehicles_registered: "No tienes vehículos registrados.",
    veh_th_code_plate: "Código / Patente",
    veh_th_features: "Características",
    veh_th_type: "Tipo Vehículo",
    veh_th_shift_driver: "Chofer de Turno",
    btn_end_shift: "Finalizar Turno",
    btn_start_shift: "Iniciar Turno",
    no_color_specified: "Color no esp.",
    shift_lbl: "Turno",
    allowed_range: "Rango permitido",
    suggested_available: "Sugeridos disponibles",
    claims_title: "⚠️ Reclamos e Incidencias (Booking.com)",
    claims_subtitle: "Gestión de reclamos reportados en reservas asignadas a tu flota. Ingresa tus descargos y evidencia.",
    claims_subtab_pending: "⚠️ Pendientes",
    claims_subtab_submitted: "✅ Respondidos a Booking",
    claims_subtab_history: "📁 Historial",
    claims_subtab_all: "Todas",
    claims_no_pending: "¡Sin reclamos pendientes por responder!",
    claims_no_pending_desc: "Tu flota no registra reclamos activos pendientes de descargos.",
    tariffs_title: "💵 Mi Tarifario Autogestionado",
    tariffs_subtitle: "Gestiona y actualiza los precios de costo local en tu moneda para cada ruta asignada.",
    tariffs_bulk_btn: "⚡ Actualización Masiva",
    tariffs_genius_btn: "⭐ Genius Masivo",
    tariffs_save_all: "Guardar Todos",
    tariffs_saving: "Guardando...",
    tariffs_search_origin: "🔍 Buscar Origen...",
    tariffs_search_dest: "🔍 Buscar Destino...",
    tariffs_passengers: "👤 Pasajeros",
    tariffs_vehicles_all: "🚗 Vehículo (Todos)",
    tariffs_custom_types_title: "Tipos de Vehículo Personalizados",
    tariffs_custom_types_subtitle: "Crea capacidades de vehículos que no estén en la configuración global para tu autogestión.",
    btn_create_vehicle_type: "Crear Tipo de Vehículo",
    quality_title: "Calidad & Opinión de Pasajeros",
    quality_subtitle: "Monitorea las evaluaciones reales dejadas por los pasajeros de Booking.com al finalizar cada viaje asignado a tu flota.",
    filter_from: "Desde",
    filter_to: "Hasta",
    all_drivers_option: "Todos los conductores",
    filter_results_btn: "Filtrar Resultados",
    kpi_overall_avg: "PROMEDIO GENERAL",
    kpi_official_goal: "Meta oficial: 4.60+",
    kpi_sla_compliance: "CUMPLIMIENTO SLA",
    kpi_scores_ge: "Notas >= 4.6",
    kpi_total_evaluations: "TOTAL EVALUACIONES",
    kpi_surveys_period: "Encuestas en el periodo",
    kpi_evals_to_improve: "EVALUACIONES A MEJORAR",
    kpi_click_to_see_lt: "Click para ver notas < 4.6",
    kpi_seeing_lt: "Viendo notas < 4.6 (Click para ver todas)",
    surveys_section_title: "Encuestas & Feedback de Pasajeros Booking",
    search_surveys_ph: "🔍 Buscar por conductor, ref o comentario...",
    th_date: "Fecha",
    th_ref_booking: "Ref / Reserva",
    th_zone_base: "Zona / Base",
    th_passenger_score: "Calificación Pasajero",
    th_passenger_comment: "Comentario del Pasajero",
    th_detail: "Detalle",
    route_orig_dest: "Ruta (Origen ➔ Destino)",
    th_currency: "Moneda",
    th_provider_cost: "Costo Proveedor (Local)",
    th_bid_discount: "% Puja Desc",
    th_genius_discount: "% Genius",
    th_action: "Acción",
    save: "Guardar",
    save_changes: "Guardar Cambios",
    modified_badge: "Modificado",
    clear: "Limpiar",
    no_tariffs_found: "No se encontraron tarifas que coincidan con los filtros.",
    inactive_male: "Inactivo",
    pax_word: "Pasajeros",
    suitcases_word: "Maletas",
    veh_type_name_th: "Nombre del Tipo de Vehículo",
    veh_type_max_pax_th: "Capacidad Máxima (Pasajeros)",
    veh_type_max_suitcases_th: "Capacidad Maletas",
    veh_type_booking_cat_th: "Categoría en Booking.com",
    none_option: "- Ninguno -",
    own_badge: "Propio",
    global_system_badge: "Global (Sistema)",
    blocked_badge: "- Bloqueado -",
    no_vehicle_types_registered: "No hay tipos de vehículos registrados.",
    th_os_booking: "O.S. / Reserva",
    th_claim_type: "Tipo de Reclamo",
    th_penalty: "Penalización",
    th_appeal_status: "Estado Apelación",
    btn_view_detail: "Ver Detalle",
    btn_view_appeal: "Ver Apelación",
    btn_respond_claim: "Responder Reclamo",
    status_under_review: "En Revisión",
  },

  pt: {
    // Header & Perfil Conductor
    available: "DISPONÍVEL",
    paused: "EM PAUSA",
    mobile: "Veículo",
    change: "Alterar",
    push_ok: "PUSH OK",
    configure: "CONFIGURAR",
    today: "HOJE",
    current_month: "MÊS ATUAL",
    view_list: "VER LISTA",
    gps_permission: "PERMISSÃO GPS",
    view_notice: "📍 VER AVISO",
    my_profile: "Meu Perfil",
    logout: "Sair",
    admin: "ADMIN",
    language: "Idioma",
    phone: "TELEFONE",
    email: "EMAIL",
    role: "FUNÇÃO",
    not_registered: "Não registrado",
    my_documents: "Meus Documentos",
    service_certificate: "Certificado de Serviços",
    my_payments_settlements: "Meus Pagamentos / Liquidações",
    my_schedule_availability: "Meu Horário e Disponibilidade",
    close: "Fechar",
    delete_account: "Excluir Conta",

    // Pestañas Conductor (Tabs)
    tab_new: "NOVOS",
    tab_agenda: "AGENDA",
    tab_tomorrow: "AMANHÃ",
    tab_history: "HISTÓRICO",
    tab_payments: "PAGAMENTOS",

    // Estados de viaje (Badges & Tablas)
    status_pending: "Pendente",
    status_assigned: "Atribuído",
    status_confirmed: "Confirmado",
    status_en_route: "A Caminho",
    status_arrived: "No Local (Cheguei)",
    status_on_board: "A Bordo / Em Rota",
    status_completed: "Concluído",
    status_cancelled: "Cancelado",
    status_cancelled_paid: "Cancelado com Cobrança",
    status_no_show: "Não Compareceu (No-Show)",
    status_anulado: "ANULADO",

    // Acciones y Botones del Conductor
    btn_accept: "¡ACEITAR!",
    btn_reject: "RECUSAR",
    btn_start_trip: "A CAMINHO",
    btn_arrived: "CHEGUEI À ORIGEM",
    btn_onboard: "PASSAGEIRO A BORDO",
    btn_finish: "FINALIZAR CORRIDA",
    btn_navigate: "Navegar",
    btn_call: "Ligar",
    btn_whatsapp: "WhatsApp",
    btn_flight: "Voo",
    btn_chat: "Chat Passageiro",
    btn_release_trip: "⚠️ Não posso realizar esta viagem (Liberar)",
    release_trip_confirm: "Liberar este serviço? Será devolvido à central.",
    time_restriction_notice: "* Será habilitado 2 horas antes do serviço.",

    // Detalles del Servicio
    lbl_passenger: "Passageiro",
    lbl_origin: "Origem",
    lbl_destination: "Destino",
    lbl_pickup_time: "Horário de embarque",
    lbl_flight: "Voo",
    lbl_suitcases: "Malas",
    lbl_notes: "Observações",
    lbl_earnings: "Ganho",
    lbl_cost_center: "Centro de Custo",
    lbl_no_trips: "Você não tem serviços agendados nesta seção.",
    lbl_waiting_time: "Tempo de espera",
    lbl_contact: "Contatar Passageiro",

    // Ofertas ASAP / Urgentes
    asap_title: "¡NOVO SERVIÇO IMEDIATO DISPONÍVEL!",
    asap_subtitle: "Um serviço urgente requer confirmação rápida.",
    asap_expires: "Expira em",

    // Liquidaciones
    settlements_title: "Meus Pagamentos",
    settlements_no_records: "Nenhum pagamento registrado ainda.",
    settlement_period: "Período",
    settlement_amount: "Total a Receber",
    settlement_trips: "Corridas",
    settlement_status_paid: "PAGO",
    settlement_status_pending: "PENDENTE",
    btn_download_receipt: "Ver Comprovante",

    // Portal Proveedor - Navegación Principal
    provider_title: "EmiGo Parceiros",
    provider_role_badge: "PARCEIRO",
    provider_syncing: "Sincronizando dados...",
    provider_dispatch_tab: "📅 Despacho e Viagens",
    provider_claims_tab: "⚠️ Reclamações e Ocorrências",
    provider_fleet_tab: "🚙 Minha Frota",
    provider_tariffs_tab: "💰 Minhas Tarifas",
    provider_sentinel_tab: "🤖 Robô Sentinela",
    provider_quality_tab: "⭐ Qualidade",
    provider_subtab_active: "Em Andamento / A Despachar",
    provider_subtab_history: "Histórico",
    provider_schedule_btn: "Enviar Agenda aos Motoristas",
    provider_no_trips: "Nenhum serviço encontrado para os filtros selecionados.",

    // Portal Proveedor - Despacho Diario & Filtros
    daily_dispatch: "Despacho Diário",
    all: "Todos",
    today_filter: "Hoje",
    month: "Mês",
    range: "📅 Intervalo",
    dispatch_subtab_speech: "Despacho Ativo",
    history: "Histórico",
    reload: "🔄 Recarregar",
    unassigned: "Não Atribuído",
    filters: "Filtros",
    filter_clients: "Clientes...",
    filter_driver_vehicle: "Veículo / Motorista...",
    filter_status: "Status...",
    filter_areas: "Áreas...",
    filter_cost_centers: "Centros de Custo...",
    filter_requesters: "Solicitantes...",
    filter_passenger: "Passageiro...",
    services_count: "SERVIÇOS",
    total_estimated_payment: "PAGAMENTO ESTIMADO TOTAL",
    total_payment: "PAGAMENTO TOTAL",
    estimated_payment: "PAGAMENTO ESTIMADO",
    active_dispatch_title: "Despacho Ativo",
    in_course: "Em Curso",
    completed_count: "Concluídos",
    no_services_found: "Nenhum serviço encontrado nesta seção.",

    // Portal Proveedor - Columnas Tabla
    th_datetime: "Data/Hora",
    th_type: "Tipo",
    th_client: "Cliente",
    th_passenger: "Passageiro",
    th_route: "Rota (Origem / Destino)",
    th_general_notes: "Obs. Gerais",
    th_driver_notes: "Obs. Motorista",
    th_estimated_time: "T. Est",
    th_status: "Status",
    th_est_payment: "Pagamento Est.",
    th_payment: "Pagamento",
    th_vehicle: "Veículo",
    th_actions: "Ações",

    // Portal Proveedor - Botones de Tabla & Filas
    assign: "Atribuir",
    assign_vehicle: "Atribuir Veículo",
    change_btn: "Alterar",
    confirm: "Confirmar",
    accept: "Aceitar",
    start_route: "▶ Iniciar Rota",
    arrived_origin: "📍 Chegou na Origem",
    passenger_onboard: "👋 Passageiro a Bordo",
    finish_trip: "🏁 Finalizar Corrida",
    release: "✕ Liberar",
    manage_urgent: "GERENCIAR!",
    urgent: "URGENTE",
    no_driver: "Sem motorista atribuído",
    driver_word: "Motorista",
    vehicle_word: "Veículo",
    vehicle_not_assigned: "⚠️ Veículo Não Atribuído",
    audit_trip: "Auditar",
    page_x_of_y: "Pág",
    view_per_page: "Ver:",

    // Portal Proveedor - Pestaña Mi Flota
    fleet_title: "🚙 Autogestão de Frota",
    fleet_subtitle: "Gerencie os motoristas, veículos e turnos ativos em sua região.",
    tab_drivers: "👤 Motoristas",
    tab_vehicles: "🚙 Veículos",
    tab_capacities: "⚙️ Capacidades",
    drivers_list_title: "Lista de Motoristas",
    register_driver_btn: "Cadastrar Motorista",
    no_drivers_registered: "Você não tem motoristas cadastrados.",
    driver_th_name_rut: "Nome / CPF/ID",
    driver_th_contact_email: "Contato / Email",
    driver_th_shift_status: "Status do Turno",
    driver_th_assigned_vehicle: "Veículo Atribuído",
    online: "Online",
    offline: "Inativo",
    on_shift_online: "Em Turno (Online)",
    off_service: "Fora de Serviço",
    no_vehicle: "Sem veículo",
    edit: "Editar",

    // Modales Conductor / Vehículo
    new_driver_title: "👤 Novo Motorista",
    edit_driver_title: "👤 Editar Motorista",
    full_name_lbl: "Nome Completo *",
    rut_id_lbl: "CPF / Identificação *",
    phone_lbl: "Telefone *",
    email_user_lbl: "Email / Usuário *",
    password_lbl: "Senha de Acesso",
    password_keep_ph: "Deixe em branco para manter",
    password_min_ph: "Mínimo 6 caracteres",
    active_driver_lbl: "Motorista Ativo",
    show_pricing_lbl: "Permitir ver preços das corridas no portal móvel",
    cancel: "Cancelar",
    save_driver_btn: "Salvar Motorista",

    new_vehicle_title: "🚙 Novo Veículo",
    edit_vehicle_title: "🚙 Editar Veículo",
    internal_code_lbl: "Código Interno / Veículo *",
    plate_lbl: "Placa *",
    brand_lbl: "Marca *",
    model_lbl: "Modelo *",
    year_lbl: "Ano *",
    color_lbl: "Cor",
    category_lbl: "Tipo / Capacidade *",
    assigned_driver_lbl: "Motorista Associado",
    active_vehicle_lbl: "Veículo Ativo",
    save_vehicle_btn: "Salvar Veículo",

    // Modal Asignar / Editar Viaje
    assign_modal_title: "📋 Atribuir / Editar Reserva",
    assign_modal_vehicle: "Veículo *",
    assign_modal_select_vehicle: "- Selecione o Veículo -",
    assign_modal_assigned_driver: "Motorista Atribuído",
    assign_modal_no_driver_warning: "Não há motorista pré-associado a este veículo",
    assign_modal_link_driver_tip: "⚠️ O veículo selecionado não tem motorista associado. Vincule-o em \"Minha Frota\" antes de atribuir.",
    assign_modal_notes: "Observações Gerais",
    assign_modal_driver_notes: "Observações do Motorista",
    assign_modal_confirm: "Confirmar Atribuição",
    waiting_new_services: "Aguardando novas corridas...",
    no_confirmed_trips_agenda: "Nenhuma corrida confirmada na agenda.",
    no_trips_tomorrow: "Você não tem corridas agendadas para amanhã.",
    accept_trip_card: "Aceitar Corrida",
    btn_accept_service: "Aceitar Serviço",
    trip_in_progress: "CORRIDA EM ANDAMENTO...",
    trips_history_title: "Histórico de Corridas",
    loading_month_history: "Carregando histórico do mês...",
    no_history_this_month: "Nenhuma corrida no histórico para este mês.",
    agreement: "Convênio",
    agenda_pending_confirm: "AGENDA PENDENTE DE CONFIRMAR",
    confirm_agenda_reading: "✓ Confirmar Leitura / Ciente",
    agenda_confirmed: "¡Agenda Confirmada!",
    agenda_confirmed_on: "Você confirmou a revisão em",
    at_time_hrs: "às",
    passenger_list: "LISTA DE PASSAGEIROS",
    pax_principal: "Principal",
    pax_companion: "Acompanhante",
    stop_word: "Parada",
    flight_label: "Voo",
    no_phone: "Sem Telefone",
    no_phone_short: "Sem tel.",
    status_scheduled: "AGENDADO",
    new_badge: "NOVO",
    close_map: "Fechar Mapa",
    view_map_route: "VER MAPA COM ROTA",
    service_title: "SERVIÇO",
    schedule_btn: "Agendar",
    extra_services_title: "SERVIÇOS ADICIONAIS (EXTRAS)",
    lbl_origin_caps: "ORIGEM",
    lbl_destination_caps: "DESTINO",
    intermediate_stops: "PARADAS INTERMEDIÁRIAS",
    general_observations: "OBSERVAÇÕES GERAIS",
    trip_comments_title: "NOVIDADES / OBSERVAÇÕES DA CORRIDA",
    trip_comments_ph: "Escreva aqui se houver alguma novidade...",
    arrived_at_stop: "CHEGUEI NA PARADA",
    continue_trip_leave: "CONTINUAR CORRIDA (SAIR)",
    completion_summary_title: "Resumo da Finalização",
    completion_details_subtitle: "Detalhes do serviço concluído:",
    distance_covered: "DISTÂNCIA PERCORRIDA",
    waiting_time_caps: "TEMPO DE ESPERA",
    trip_fare: "TARIFA DA CORRIDA",
    waiting_payment: "PAGAMENTO POR ESPERA",
    important_notice: "Aviso Importante",
    understood: "Entendi",
    pax_on_board_question: "Passageiro(s) a Bordo?",
    yes: "Sim",
    no: "Não",
    trips_today: "Corridas de Hoje",
    trips_month: "Corridas do Mês",
    no_trips_period: "Nenhuma corrida concluída registrada neste período.",
    total_period: "TOTAL DO PERÍODO",
    gps_usage_title: "Uso de Localização GPS",
    gps_disclosure_text: "Flujo App (EmiGo) coleta e transmite dados de localização GPS para permitir o rastreamento em tempo real dos serviços de transporte atribuídos aos motoristas.",
    gps_background_title: "📌 Transmissão em Segundo Plano:",
    gps_background_desc: "A posição do seu veículo será compartilhada com a central de operações e passageiros durante uma corrida ativa, mesmo com o aplicativo minimizado ou a tela desligada.",
    understood_and_continue: "Entendi e Continuar",
    no_settlements_month: "Você não tem pagamentos para este mês.",
    refresh: "Atualizar",
    setup_guide_title: "MANUAL DE CONFIGURAÇÃO",
    setup_guide_subtitle: "Siga estes passos para receber corridas instantaneamente e o GPS não falhar.",
    setup_battery_title: "1. Bateria (Sem Restrições)",
    setup_battery_step1: "Vá para as Configurações do seu telefone.",
    setup_battery_step2: "Procure Aplicativos e selecione EmiGo.",
    setup_battery_step3: "Entre em Bateria.",
    setup_battery_step4: "Selecione \"SEM RESTRIÇÕES\" (ou \"Otimização Desativada\").",
    setup_why: "Por quê? ",
    setup_battery_desc: "Se você não fizer isso, o Android suspende o app e você não receberá corridas urgentes (ASAP).",
    setup_data_title: "2. Dados em Segundo Plano",
    setup_data_step1: "No mesmo menu do app (EmiGo), entre em Dados Móveis.",
    setup_data_step2: "Ative \"Permitir uso de dados em segundo plano\".",
    setup_data_step3: "Ative \"Permitir uso de dados com economia de dados\".",
    setup_notif_title: "3. Notificações e Som",
    setup_notif_step1: "Certifique-se de que em Notificações todas as chaves estejam ATIVADAS.",
    setup_notif_step2: "Verifique se o volume das notificações está alto.",
    setup_btn_understood: "¡ENTENDI, JÁ CONFIGUREI!",
    perm_title: "CONFIGURAÇÃO NECESSÁRIA",
    perm_greeting: "Olá! Para receber corridas...",
    perm_desc: "Precisamos que você ative as permissões de GPS e Notificações.",
    perm_gps_title: "GPS (Localização)",
    perm_gps_desc: "EmiGo coleta dados de localização para permitir o rastreamento em tempo real de suas corridas e a atribuição de serviços próximos, mesmo com o aplicativo fechado ou fora de uso.",
    perm_notif_title: "Notificações",
    perm_notif_desc: "Para avisar instantaneamente quando você tiver uma nova corrida.",
    perm_battery_title: "Bateria (Sem Restrições)",
    perm_battery_desc: "Muito importante para que o Android não suspenda o app.",
    perm_warning: "Ao tocar no botão, o aparelho perguntará. Selecione \"PERMITIR SEMPRE\".",
    perm_btn_configure: "CONFIGURAR AGORA",
    vehicles_list_title: "Lista de Veículos",
    register_vehicle_btn: "Cadastrar Veículo",
    no_vehicles_registered: "Você não tem veículos cadastrados.",
    veh_th_code_plate: "Código / Placa",
    veh_th_features: "Características",
    veh_th_type: "Tipo de Veículo",
    veh_th_shift_driver: "Motorista de Turno",
    btn_end_shift: "Finalizar Turno",
    btn_start_shift: "Iniciar Turno",
    no_color_specified: "Cor não especificada",
    shift_lbl: "Turno",
    allowed_range: "Intervalo permitido",
    suggested_available: "Sugeridos disponíveis",
    claims_title: "⚠️ Reclamações e Ocorrências (Booking.com)",
    claims_subtitle: "Gestão de reclamações reportadas em reservas atribuídas à sua frota. Insira suas respostas e evidências.",
    claims_subtab_pending: "⚠️ Pendentes",
    claims_subtab_submitted: "✅ Respondidos à Booking",
    claims_subtab_history: "📁 Histórico",
    claims_subtab_all: "Todas",
    claims_no_pending: "¡Sem reclamações pendentes!",
    claims_no_pending_desc: "Sua frota não registra reclamações ativas pendentes de resposta.",
    tariffs_title: "💵 Minhas Tarifas Autogerenciadas",
    tariffs_subtitle: "Gerencie e atualize os preços de custo local em sua moeda para cada rota atribuída.",
    tariffs_bulk_btn: "⚡ Atualização em Massa",
    tariffs_genius_btn: "⭐ Genius em Massa",
    tariffs_save_all: "Salvar Todos",
    tariffs_saving: "Salvando...",
    tariffs_search_origin: "🔍 Buscar Origem...",
    tariffs_search_dest: "🔍 Buscar Destino...",
    tariffs_passengers: "👤 Passageiros",
    tariffs_vehicles_all: "🚗 Veículo (Todos)",
    tariffs_custom_types_title: "Tipos de Veículos Personalizados",
    tariffs_custom_types_subtitle: "Crie capacidades de veículos que não estejam na configuração global para sua autogestão.",
    btn_create_vehicle_type: "Criar Tipo de Veículo",
    quality_title: "Qualidade & Opinião dos Passageiros",
    quality_subtitle: "Monitore as avaliações reais deixadas pelos passageiros da Booking.com ao finalizar cada corrida atribuída à sua frota.",
    filter_from: "De",
    filter_to: "Até",
    all_drivers_option: "Todos os motoristas",
    filter_results_btn: "Filtrar Resultados",
    kpi_overall_avg: "MÉDIA GERAL",
    kpi_official_goal: "Meta oficial: 4.60+",
    kpi_sla_compliance: "CUMPRIMENTO DO SLA",
    kpi_scores_ge: "Notas >= 4.6",
    kpi_total_evaluations: "TOTAL DE AVALIAÇÕES",
    kpi_surveys_period: "Pesquisas no período",
    kpi_evals_to_improve: "AVALIAÇÕES A MELHORAR",
    kpi_click_to_see_lt: "Clique para ver notas < 4.6",
    kpi_seeing_lt: "Visualizando notas < 4.6 (Clique para ver todas)",
    surveys_section_title: "Pesquisas & Feedback dos Passageiros Booking",
    search_surveys_ph: "🔍 Buscar por motorista, ref ou comentário...",
    th_date: "Data",
    th_ref_booking: "Ref / Reserva",
    th_zone_base: "Região / Base",
    th_passenger_score: "Nota do Passageiro",
    th_passenger_comment: "Comentário do Passageiro",
    th_detail: "Detalhes",
    route_orig_dest: "Rota (Origem ➔ Destino)",
    th_currency: "Moeda",
    th_provider_cost: "Custo Parceiro (Local)",
    th_bid_discount: "% Lance Desc",
    th_genius_discount: "% Genius",
    th_action: "Ação",
    save: "Salvar",
    save_changes: "Salvar Alterações",
    modified_badge: "Modificado",
    clear: "Limpar",
    no_tariffs_found: "Nenhuma tarifa encontrada com os filtros selecionados.",
    inactive_male: "Inativo",
    pax_word: "Passageiros",
    suitcases_word: "Malas",
    veh_type_name_th: "Nome do Tipo de Veículo",
    veh_type_max_pax_th: "Capacidade Máxima (Passageiros)",
    veh_type_max_suitcases_th: "Capacidade de Malas",
    veh_type_booking_cat_th: "Categoria na Booking.com",
    none_option: "- Nenhum -",
    own_badge: "Próprio",
    global_system_badge: "Global (Sistema)",
    blocked_badge: "- Bloqueado -",
    no_vehicle_types_registered: "Nenhum tipo de veículo cadastrado.",
    th_os_booking: "O.S. / Reserva",
    th_claim_type: "Tipo de Reclamação",
    th_penalty: "Penalização",
    th_appeal_status: "Status da Apelação",
    btn_view_detail: "Ver Detalhes",
    btn_view_appeal: "Ver Apelação",
    btn_respond_claim: "Responder Reclamação",
    status_under_review: "Em Revisão",
  },

  en: {
    // Header & Perfil Conductor
    available: "AVAILABLE",
    paused: "ON BREAK",
    mobile: "Vehicle",
    change: "Change",
    push_ok: "PUSH OK",
    configure: "CONFIGURE",
    today: "TODAY",
    current_month: "CURRENT MONTH",
    view_list: "VIEW LIST",
    gps_permission: "GPS PERMISSION",
    view_notice: "📍 VIEW NOTICE",
    my_profile: "My Profile",
    logout: "Log Out",
    admin: "ADMIN",
    language: "Language",
    phone: "PHONE",
    email: "EMAIL",
    role: "ROLE",
    not_registered: "Not registered",
    my_documents: "My Documents",
    service_certificate: "Service Certificate",
    my_payments_settlements: "My Payments / Settlements",
    my_schedule_availability: "My Schedule & Availability",
    close: "Close",
    delete_account: "Delete Account",

    // Pestañas Conductor (Tabs)
    tab_new: "NEW",
    tab_agenda: "SCHEDULE",
    tab_tomorrow: "TOMORROW",
    tab_history: "HISTORY",
    tab_payments: "PAYOUTS",

    // Estados de viaje (Badges & Tablas)
    status_pending: "Pending",
    status_assigned: "Assigned",
    status_confirmed: "Confirmed",
    status_en_route: "En Route",
    status_arrived: "Arrived",
    status_on_board: "Passenger On Board",
    status_completed: "Completed",
    status_cancelled: "Cancelled",
    status_cancelled_paid: "Cancelled (Billable)",
    status_no_show: "No Show",
    status_anulado: "VOIDED",

    // Acciones y Botones del Conductor
    btn_accept: "ACCEPT!",
    btn_reject: "DECLINE",
    btn_start_trip: "EN ROUTE",
    btn_arrived: "ARRIVED AT PICKUP",
    btn_onboard: "PASSENGER ON BOARD",
    btn_finish: "COMPLETE TRIP",
    btn_navigate: "Navigate",
    btn_call: "Call",
    btn_whatsapp: "WhatsApp",
    btn_flight: "Flight",
    btn_chat: "Passenger Chat",
    btn_release_trip: "⚠️ Cannot take this trip (Release)",
    release_trip_confirm: "Release this trip? It will be returned to dispatch.",
    time_restriction_notice: "* Will be enabled 2 hours before the service.",

    // Detalles del Servicio
    lbl_passenger: "Passenger",
    lbl_origin: "Pickup",
    lbl_destination: "Dropoff",
    lbl_pickup_time: "Pickup Time",
    lbl_flight: "Flight",
    lbl_suitcases: "Baggage",
    lbl_notes: "Notes",
    lbl_earnings: "Earnings",
    lbl_cost_center: "Cost Center",
    lbl_no_trips: "No scheduled trips in this section.",
    lbl_waiting_time: "Waiting time",
    lbl_contact: "Contact Passenger",

    // Ofertas ASAP / Urgentes
    asap_title: "NEW IMMEDIATE RIDE AVAILABLE!",
    asap_subtitle: "An urgent ride requires quick confirmation.",
    asap_expires: "Expires in",

    // Liquidaciones
    settlements_title: "My Settlements",
    settlements_no_records: "No settlement records found yet.",
    settlement_period: "Period",
    settlement_amount: "Total Payout",
    settlement_trips: "Trips",
    settlement_status_paid: "PAID",
    settlement_status_pending: "PENDING",
    btn_download_receipt: "View Receipt",

    // Portal Proveedor - Navegación Principal
    provider_title: "EmiGo Partners",
    provider_role_badge: "PARTNER",
    provider_syncing: "Syncing data...",
    provider_dispatch_tab: "📅 Dispatch & Trips",
    provider_claims_tab: "⚠️ Claims & Incidents",
    provider_fleet_tab: "🚙 My Fleet",
    provider_tariffs_tab: "💰 My Tariffs",
    provider_sentinel_tab: "🤖 Sentinel Bot",
    provider_quality_tab: "⭐ Quality",
    provider_subtab_active: "Active / To Dispatch",
    provider_subtab_history: "History",
    provider_schedule_btn: "Send Schedule to Drivers",
    provider_no_trips: "No services found for the selected filters.",

    // Portal Proveedor - Despacho Diario & Filtros
    daily_dispatch: "Daily Dispatch",
    all: "All",
    today_filter: "Today",
    month: "Month",
    range: "📅 Range",
    dispatch_subtab_speech: "Live Dispatch",
    history: "History",
    reload: "🔄 Reload",
    unassigned: "Unassigned",
    filters: "Filters",
    filter_clients: "Clients...",
    filter_driver_vehicle: "Vehicle / Driver...",
    filter_status: "Statuses...",
    filter_areas: "Areas...",
    filter_cost_centers: "Cost Centers...",
    filter_requesters: "Requesters...",
    filter_passenger: "Passenger...",
    services_count: "SERVICES",
    total_estimated_payment: "TOTAL ESTIMATED PAYMENT",
    total_payment: "TOTAL PAYMENT",
    estimated_payment: "ESTIMATED PAYMENT",
    active_dispatch_title: "Active Dispatch",
    in_course: "In Progress",
    completed_count: "Completed",
    no_services_found: "No services found in this section.",

    // Portal Proveedor - Columnas Tabla
    th_datetime: "Date/Time",
    th_type: "Type",
    th_client: "Client",
    th_passenger: "Passenger",
    th_route: "Route (Origin / Destination)",
    th_general_notes: "General Notes",
    th_driver_notes: "Driver Notes",
    th_estimated_time: "Est. Time",
    th_status: "Status",
    th_est_payment: "Est. Payment",
    th_payment: "Payment",
    th_vehicle: "Vehicle",
    th_actions: "Actions",

    // Portal Proveedor - Botones de Tabla & Filas
    assign: "Assign",
    assign_vehicle: "Assign Vehicle",
    change_btn: "Change",
    confirm: "Confirm",
    accept: "Accept",
    start_route: "▶ Start Route",
    arrived_origin: "📍 Arrived at Pickup",
    passenger_onboard: "👋 Passenger On Board",
    finish_trip: "🏁 Complete Trip",
    release: "✕ Release",
    manage_urgent: "MANAGE!",
    urgent: "URGENT",
    no_driver: "No driver assigned",
    driver_word: "Driver",
    vehicle_word: "Vehicle",
    vehicle_not_assigned: "⚠️ Vehicle Not Assigned",
    audit_trip: "Audit",
    page_x_of_y: "Page",
    view_per_page: "View:",

    // Portal Proveedor - Pestaña Mi Flota
    fleet_title: "🚙 Fleet Management",
    fleet_subtitle: "Manage drivers, vehicles, and active shifts in your area.",
    tab_drivers: "👤 Drivers",
    tab_vehicles: "🚙 Vehicles",
    tab_capacities: "⚙️ Capacidades",
    drivers_list_title: "Drivers List",
    register_driver_btn: "Register Driver",
    no_drivers_registered: "No registered drivers.",
    driver_th_name_rut: "Name / ID",
    driver_th_contact_email: "Contact / Email",
    driver_th_shift_status: "Shift Status",
    driver_th_assigned_vehicle: "Assigned Vehicle",
    online: "Online",
    offline: "Inactive",
    on_shift_online: "On Shift (Online)",
    off_service: "Off Duty",
    no_vehicle: "No vehicle",
    edit: "Edit",

    // Modales Conductor / Vehículo
    new_driver_title: "👤 New Driver",
    edit_driver_title: "👤 Edit Driver",
    full_name_lbl: "Full Name *",
    rut_id_lbl: "ID / National ID *",
    phone_lbl: "Phone *",
    email_user_lbl: "Email / Username *",
    password_lbl: "Access Password",
    password_keep_ph: "Leave blank to keep",
    password_min_ph: "Minimum 6 characters",
    active_driver_lbl: "Active Driver",
    show_pricing_lbl: "Allow viewing trip prices in mobile portal",
    cancel: "Cancel",
    save_driver_btn: "Save Driver",

    new_vehicle_title: "🚙 New Vehicle",
    edit_vehicle_title: "🚙 Edit Vehicle",
    internal_code_lbl: "Internal Code / Mobile *",
    plate_lbl: "License Plate *",
    brand_lbl: "Make *",
    model_lbl: "Model *",
    year_lbl: "Year *",
    color_lbl: "Color",
    category_lbl: "Category / Capacity *",
    assigned_driver_lbl: "Associated Driver",
    active_vehicle_lbl: "Active Vehicle",
    save_vehicle_btn: "Save Vehicle",

    // Modal Asignar / Editar Viaje
    assign_modal_title: "📋 Assign / Edit Booking",
    assign_modal_vehicle: "Vehicle *",
    assign_modal_select_vehicle: "- Select Vehicle -",
    assign_modal_assigned_driver: "Assigned Driver",
    assign_modal_no_driver_warning: "No driver associated with this vehicle",
    assign_modal_link_driver_tip: "⚠️ The selected vehicle has no assigned driver. Link it in \"My Fleet\" before assigning.",
    assign_modal_notes: "General Notes",
    assign_modal_driver_notes: "Driver Notes",
    assign_modal_confirm: "Confirm Assignment",
    waiting_new_services: "Waiting for new rides...",
    no_confirmed_trips_agenda: "No confirmed rides on schedule.",
    no_trips_tomorrow: "No scheduled rides for tomorrow.",
    accept_trip_card: "Accept Ride",
    btn_accept_service: "Accept Service",
    trip_in_progress: "RIDE IN PROGRESS...",
    trips_history_title: "Ride History",
    loading_month_history: "Loading monthly history...",
    no_history_this_month: "No rides in history for this month.",
    agreement: "Agreement",
    agenda_pending_confirm: "SCHEDULE PENDING CONFIRMATION",
    confirm_agenda_reading: "✓ Confirm Read / Acknowledged",
    agenda_confirmed: "Schedule Confirmed!",
    agenda_confirmed_on: "You confirmed review on",
    at_time_hrs: "at",
    passenger_list: "PASSENGER LIST",
    pax_principal: "Main",
    pax_companion: "Companion",
    stop_word: "Stop",
    flight_label: "Flight",
    no_phone: "No Phone",
    no_phone_short: "No phone",
    status_scheduled: "SCHEDULED",
    new_badge: "NEW",
    close_map: "Close Map",
    view_map_route: "VIEW MAP & ROUTE",
    service_title: "SERVICE",
    schedule_btn: "Schedule",
    extra_services_title: "EXTRA SERVICES",
    lbl_origin_caps: "PICKUP",
    lbl_destination_caps: "DROPOFF",
    intermediate_stops: "INTERMEDIATE STOPS",
    general_observations: "GENERAL NOTES",
    trip_comments_title: "RIDE UPDATES / NOTES",
    trip_comments_ph: "Write here if any update occurred...",
    arrived_at_stop: "ARRIVED AT STOP",
    continue_trip_leave: "CONTINUE RIDE (LEAVE)",
    completion_summary_title: "Completion Summary",
    completion_details_subtitle: "Details of the completed ride:",
    distance_covered: "DISTANCE COVERED",
    waiting_time_caps: "WAITING TIME",
    trip_fare: "RIDE FARE",
    waiting_payment: "WAITING FEE",
    important_notice: "Important Notice",
    understood: "Understood",
    pax_on_board_question: "Passenger(s) on Board?",
    yes: "Yes",
    no: "No",
    trips_today: "Today's Rides",
    trips_month: "Month's Rides",
    no_trips_period: "No completed rides recorded in this period.",
    total_period: "TOTAL PERIOD",
    gps_usage_title: "GPS Location Usage",
    gps_disclosure_text: "Flujo App (EmiGo) collects and transmits GPS location data to enable real-time tracking of transport services assigned to drivers.",
    gps_background_title: "📌 Background Transmission:",
    gps_background_desc: "Your vehicle position will be shared with dispatch and passengers during an active trip, even when the app is in the background or the screen is turned off.",
    understood_and_continue: "Understood & Continue",
    no_settlements_month: "No settlements for this month.",
    refresh: "Refresh",
    setup_guide_title: "SETUP GUIDE",
    setup_guide_subtitle: "Follow these steps to receive rides instantly and ensure continuous GPS.",
    setup_battery_title: "1. Battery (Unrestricted)",
    setup_battery_step1: "Go to your phone's Settings.",
    setup_battery_step2: "Find Apps and select EmiGo.",
    setup_battery_step3: "Enter Battery.",
    setup_battery_step4: "Select \"UNRESTRICTED\" (or \"Optimization Disabled\").",
    setup_why: "Why? ",
    setup_battery_desc: "Otherwise Android puts the app to sleep and you will miss urgent rides (ASAP).",
    setup_data_title: "2. Background Data",
    setup_data_step1: "In the same app menu (EmiGo), go to Mobile Data.",
    setup_data_step2: "Enable \"Allow background data usage\".",
    setup_data_step3: "Enable \"Allow data usage while Data Saver is on\".",
    setup_notif_title: "3. Notifications & Sound",
    setup_notif_step1: "Ensure all notification toggles are turned ON.",
    setup_notif_step2: "Ensure notification volume is turned up.",
    setup_btn_understood: "GOT IT, ALL SET UP!",
    perm_title: "REQUIRED SETUP",
    perm_greeting: "Hello! To receive rides...",
    perm_desc: "We need you to enable GPS and Notification permissions.",
    perm_gps_title: "GPS (Location)",
    perm_gps_desc: "EmiGo collects location data to enable real-time tracking of your rides and assignment of nearby trips, even when the app is closed or not in use.",
    perm_notif_title: "Notifications",
    perm_notif_desc: "To instantly alert you when you have a new ride.",
    perm_battery_title: "Battery (Unrestricted)",
    perm_battery_desc: "Crucial so Android does not put the app to sleep.",
    perm_warning: "When you tap the button, your phone will prompt you. Select \"ALLOW ALL THE TIME\".",
    perm_btn_configure: "CONFIGURE NOW",
    vehicles_list_title: "Vehicles List",
    register_vehicle_btn: "Register Vehicle",
    no_vehicles_registered: "No registered vehicles.",
    veh_th_code_plate: "Code / License Plate",
    veh_th_features: "Specifications",
    veh_th_type: "Vehicle Type",
    veh_th_shift_driver: "Shift Driver",
    btn_end_shift: "End Shift",
    btn_start_shift: "Start Shift",
    no_color_specified: "Color not spec.",
    shift_lbl: "Shift",
    allowed_range: "Allowed range",
    suggested_available: "Available suggestions",
    claims_title: "⚠️ Claims & Incidents (Booking.com)",
    claims_subtitle: "Management of claims reported on bookings assigned to your fleet. Submit your responses and evidence.",
    claims_subtab_pending: "⚠️ Pending",
    claims_subtab_submitted: "✅ Replied to Booking",
    claims_subtab_history: "📁 History",
    claims_subtab_all: "All",
    claims_no_pending: "No pending claims to reply!",
    claims_no_pending_desc: "Your fleet has no active claims awaiting response.",
    tariffs_title: "💵 My Self-Managed Tariffs",
    tariffs_subtitle: "Manage and update local cost prices in your currency for each assigned route.",
    tariffs_bulk_btn: "⚡ Bulk Update",
    tariffs_genius_btn: "⭐ Bulk Genius",
    tariffs_save_all: "Save All",
    tariffs_saving: "Saving...",
    tariffs_search_origin: "🔍 Search Origin...",
    tariffs_search_dest: "🔍 Search Destination...",
    tariffs_passengers: "👤 Passengers",
    tariffs_vehicles_all: "🚗 Vehicle (All)",
    tariffs_custom_types_title: "Custom Vehicle Types",
    tariffs_custom_types_subtitle: "Create vehicle capacities not in the global configuration for your management.",
    btn_create_vehicle_type: "Create Vehicle Type",
    quality_title: "Quality & Passenger Feedback",
    quality_subtitle: "Monitor real passenger feedback from Booking.com upon completion of rides assigned to your fleet.",
    filter_from: "From",
    filter_to: "To",
    all_drivers_option: "All drivers",
    filter_results_btn: "Filter Results",
    kpi_overall_avg: "OVERALL AVERAGE",
    kpi_official_goal: "Official goal: 4.60+",
    kpi_sla_compliance: "SLA COMPLIANCE",
    kpi_scores_ge: "Scores >= 4.6",
    kpi_total_evaluations: "TOTAL REVIEWS",
    kpi_surveys_period: "Surveys in period",
    kpi_evals_to_improve: "REVIEWS TO IMPROVE",
    kpi_click_to_see_lt: "Click to see scores < 4.6",
    kpi_seeing_lt: "Viewing scores < 4.6 (Click to see all)",
    surveys_section_title: "Booking Passenger Surveys & Feedback",
    search_surveys_ph: "🔍 Search by driver, ref or comment...",
    th_date: "Date",
    th_ref_booking: "Ref / Booking",
    th_zone_base: "Zone / Base",
    th_passenger_score: "Passenger Rating",
    th_passenger_comment: "Passenger Comment",
    th_detail: "Details",
    route_orig_dest: "Route (Origin ➔ Destination)",
    th_currency: "Currency",
    th_provider_cost: "Partner Cost (Local)",
    th_bid_discount: "% Bid Disc",
    th_genius_discount: "% Genius",
    th_action: "Action",
    save: "Save",
    save_changes: "Save Changes",
    modified_badge: "Modified",
    clear: "Clear",
    no_tariffs_found: "No tariffs found matching the filters.",
    inactive_male: "Inactive",
    pax_word: "Passengers",
    suitcases_word: "Luggage",
    veh_type_name_th: "Vehicle Type Name",
    veh_type_max_pax_th: "Max Capacity (Passengers)",
    veh_type_max_suitcases_th: "Luggage Capacity",
    veh_type_booking_cat_th: "Booking.com Category",
    none_option: "- None -",
    own_badge: "Custom",
    global_system_badge: "Global (System)",
    blocked_badge: "- Locked -",
    no_vehicle_types_registered: "No registered vehicle types.",
    th_os_booking: "Order / Booking",
    th_claim_type: "Claim Type",
    th_penalty: "Penalty",
    th_appeal_status: "Appeal Status",
    btn_view_detail: "View Details",
    btn_view_appeal: "View Appeal",
    btn_respond_claim: "Reply to Claim",
    status_under_review: "Under Review",
  }
};
